import { Component, ComponentFactoryResolver, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NicaMaster } from '../../../components/nica-master-component/nica-master.component';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { Apiservice } from '../../../services/api.service';
import { ComponentService } from '../../../services/component.service';
import { FormsTemplateService } from '../../../services/forms-template.service';
import { OverlaySideFormService } from '../../../components/shared/overlay-side-form/overlay-side-form.service';
import { NicaMenuService } from '../../../services/nica-menu.service';
import { RentriService } from '../../../services/rentri.service';
import { AnagraficaService } from '../../../services/anagrafica.service';
import { HttpClient } from '@angular/common/http';
import { alert } from 'devextreme/ui/dialog';

@Component({
  selector: 'app-giacenze-rifiuto-movimento',
  templateUrl: './giacenze-rifiuto-movimento.component.html',
  styleUrls: ['./giacenze-rifiuto-movimento.component.css']
})
export class GiacenzeRifiutoMovimentoComponent extends NicaMaster implements OnInit {
  @Input() itemData: any;
  @Output() outputEmit: EventEmitter<any> = new EventEmitter<any>(); //Emit all'esterno
  @Output() emittendSelectionRow: EventEmitter<any> = new EventEmitter<any>(); //Emit all'esterno
  @Output() onAllEvent: EventEmitter<any> = new EventEmitter<any>(); //Emit all'esterno
  startForm: boolean = false;
  listaGiacenzaRifiuti: any[] = [];

  constructor(
    private activateRoute: ActivatedRoute,


    public apiservice: Apiservice,


    public userComponentService: ComponentService,
    public templateService: FormsTemplateService,
    public _overlaySideFormService: OverlaySideFormService,
    public _overlaySidePanelService: OverlaySideFormService,
    public formTemplateService: FormsTemplateService,
    public _componentFactoryResolver: ComponentFactoryResolver,
    public activatedroute: ActivatedRoute,
    public router: Router,
    public menuService: NicaMenuService,
    public rentriService: RentriService,
    public anagraficaService: AnagraficaService,
    public http: HttpClient,


  ) {
    super(
      userComponentService,
      templateService,
      _overlaySideFormService,
      _overlaySidePanelService,
      formTemplateService,
      _componentFactoryResolver,
      activatedroute,
      router,
      menuService,
      rentriService,
      anagraficaService,

    );

  }

  ngOnInit() {

    this.showToolBar = false;
    
    if (this.itemData) {
      this.setGlobalVariableFromParams(this.itemData[0])
      this.titleDynamic = this.itemData[0].title
      this.buttonToolbarBottomGrid = [0]
    } else {
      this.activatedroute.queryParams
        .subscribe(params => {

          this.currentTabId = params.currentTabId,
            this.currentTabName = params.currentTabName




          this.setGlobalVariableFromParams(params);
          // this.loader.hide()

        });
    }

    this.setViewGiacenze()

  }


  async setViewGiacenze() {

    let formData = this.filterID
    let newData = [];
    let idDestinatario


    let listaMagazziniDestinatario = [];

    if (!formData.idMagazzinoDestinatario) {
      if (formData['idLotto_Sede']) {


        await this.anagraficaService.getElenco('MagazzinoRifiuti', '', '?idSede=' + formData['idLotto_Sede']).then(res => {
          if (res['items']) {
            res['items'].forEach(reee => {
              listaMagazziniDestinatario.push(reee['id']);
            })

          }

        })
        formData.ListaIdMagazzino = listaMagazziniDestinatario;
      }
    } else {

      listaMagazziniDestinatario.push(formData['idMagazzinoDestinatario']);

      formData.ListaIdMagazzino = listaMagazziniDestinatario;
    }

    if(listaMagazziniDestinatario.length==0){
      
      alert('Nessuna magazzino selezionato e nessuna giacenza disponibile','Attenzione');
      this.userComponentService.destroyCurrentOpenPopUp(this.currentTabName)
    }

    this.rowData = formData
    this.rowData['ListIdMagazzino'] = listaMagazziniDestinatario;
    this.rowData['idProduttore'] = formData['idLotto_Sede'];
    this.rowData['riferimentoEER'] = formData['riferimentoEER'];
    this.rowData['dataRegistrazione'] = formData['dataRegistrazione'];

    if (listaMagazziniDestinatario.length > 0) {

      let apiGiacenza = 'GiacenzaRifiuti/GetElencoRifiutiScaricabili';
      let queryString = ''


      if (formData.eer && formData.idStatoFisico && formData.riferimentoEER) {
        //queryString += `/GetByEerRifer?EER="${formData.eer}&IdStatoFisico=${formData.idStatoFisico}&RiferimentoEER=${formData.idStatoFisico}`;
      }
      if (!queryString) {
        queryString += "?AllaData=" + formData.dataRegistrazione
      } else {
        queryString += "&AllaData=" + formData.dataRegistrazione
      }


      if (formData.ListaIdMagazzino) {
        formData.ListaIdMagazzino.forEach(magazzino => {
          queryString += "&ListIdMagazzino=" + magazzino;
        })
      }


      if (formData.idPosizioneRifiuto) {
        queryString += "&IdPosizioniRifiuto=" + formData.idPosizioneRifiuto;

      }
      if (formData.idLotto_Sede) {
        queryString += "&IdProduttoreDestinatario=" + formData.idLotto_Sede;

      }
      if (formData.idCantiereFuoriUl) {
        queryString += "&ListIdCantieri=" + formData.idCantiereFuoriUl;

      }


      this.anagraficaService.getElenco(apiGiacenza, '', queryString).then(res => {

        if (res['items']) {

          this.listaGiacenzaRifiuti = res['items'];
          this.startForm = true
        }
        if (res['codeMessage'] -1) {
          alert('Nessuna magazzino selezionato e nessuna giacenza disponibile','Attenzione');
          this.userComponentService.destroyCurrentOpenPopUp(this.currentTabName)
        
        }

      })
      .catch(oo=>{
        if (oo['error']['codeMessage'] -1) {
          
          this.userComponentService.destroyCurrentOpenPopUp(this.currentTabName)
        
        }
      })
    }
  }

  formEventGiacenze(event) {

    console.log('formEventCarichi', event);



    if (event.name == 'selectedItemTag') {

      const campo = event.campo.dataField;
      let dataToSend = [];

      if (campo == "ListIdMagazzino") {
        dataToSend = event.formData

        this.getCarico(dataToSend);
      }


    }
    
   

  }


  getCarico(dataToSend) {

    let formData = dataToSend

    if (formData.ListIdMagazzino.length > 0) {

      let apiGiacenza = 'GiacenzaRifiuti/GetElencoRifiutiScaricabili';
      let queryString = ''


      if (formData.eer && formData.idStatoFisico && formData.riferimentoEER) {
        queryString += `/GetByEerRifer?EER=" ${formData.eer}&IdStatoFisico=${formData.idStatoFisico}&RiferimentoEER=${formData.idStatoFisico}`;
      }
      if (!queryString) {
        queryString += "?AllaData=" + formData.dataRegistrazione
      } else {
        queryString += "&AllaData=" + formData.dataRegistrazione
      }



      if (formData.ListIdMagazzino) {
        formData.ListIdMagazzino.forEach(magazzino => {
          queryString += "&ListIdMagazzino=" + magazzino;
        })
      }


      if (formData.idPosizioneRifiuto) {
        queryString += "&IdPosizioniRifiuto=" + formData.idPosizioneRifiuto;

      }
      if (formData.idLotto_Sede) {
        queryString += "&IdProduttoreDestinatario=" + formData.idLotto_Sede;

      }
      if (formData.idCantiereFuoriUl) {
        queryString += "&ListIdCantieri=" + formData.idCantiereFuoriUl;

      }


      this.anagraficaService.getElenco(apiGiacenza, '', queryString).then(res => {

        if (res['items']) {

          this.listaGiacenzaRifiuti = res['items'];
          // this.startForm = true
        }


      })
    }
  }

  selectedRow($event) {

    console.log('selectedRow', $event)
    let dataGrid = $event.rowData ? $event.rowData : $event.data 
    let data = {
      data: {
        eer: dataGrid.eer,
        isCerPericoloso:dataGrid.isPericoloso,
        idStatoFisico: dataGrid.idStatoFisico,
        riferimentoEER: dataGrid.riferimentoEER,
        descrizioneAssegnata: dataGrid.descrizioneEER
      },
      name: "selectedRowGiacenze"
    }
    this.onAllEvent.emit(data)


    
  }

  gridEvent(event){
    if (event.name == 'onRowExpanded') {

      if(event.expandedData.length == 1){
        this.onAllEvent.emit(event)

      }

    }
  }
}
